import React from 'react';
import { Text, FlexColumn, FlexRow, SvgIcon } from '@make-software/tg-mini-app-ui';

import { SortOption } from '@/entities';
import FilterIcon from '@/shared/assets/icons/ic-filter.svg';

import { Dot, SvgContainer } from '../styled';
import { FilterMenu } from './filter-menu';

interface HackathonHeaderProps {
  filerItems?: SortOption[];
  onSelect: (label: SortOption) => void;
}

export const HackathonHeader: React.FC<HackathonHeaderProps> = ({ onSelect, filerItems }) => {
  const [selectedFilter, setSelectedFilter] = React.useState<SortOption | null>(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <>
      <FlexRow justify="space-between" align="center" style={{ width: '100%' }}>
        <FlexColumn gap={4}>
          <Text weight={1} size="lg" color="#FFFFFF" fontFamily="Inter">
            Finalists
          </Text>
          {/*<SecondaryText weight={3} size="md" color="#FFFFFF" fontFamily="Inter">*/}
          {/*  {airdropInfo?.airdrop?.round === 1*/}
          {/*    ? 'Support your favorite projects'*/}
          {/*    : 'Vote to select the winner projects'}*/}
          {/*</SecondaryText>*/}
        </FlexColumn>

        <SvgContainer openFilterMenu={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {selectedFilter === null && <Dot />}
          <SvgIcon src={FilterIcon} size={16} />
          {isMenuOpen && (
            <FilterMenu
              filerItems={filerItems || []}
              selectedFilter={selectedFilter ?? ''}
              onFilterSelect={(filter: SortOption) => {
                onSelect(filter);
                setSelectedFilter(filter);
                setIsMenuOpen(false);
              }}
            />
          )}
        </SvgContainer>
      </FlexRow>
    </>
  );
};
